
import React, { useState } from 'react';
import Button from '../base/Button';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleExplanationClick = () => {
    document.querySelector('#vapi-widget-floating-button')?.click();
  };

  return (
    <>
      {/* 準備中メッセージ */}
      <div className="bg-yellow-100 border-b border-yellow-300 py-3 text-center">
        <p className="text-xl font-bold text-yellow-800">このサイトは現在準備中です</p>
      </div>
      
      <header className="bg-white/95 backdrop-blur-sm fixed w-full top-12 z-50 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            {/* ロゴ */}
            <div className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/b9e41f94b8a653c248dde9c3c5ea5cc3/ab204bbcb2f918191a224bd0a4e09b2c.jpeg"
                alt="NextStyle高等学院"
                className="h-12 w-auto object-contain"
              />
            </div>

            {/* デスクトップナビゲーション */}
            <nav className="hidden md:flex items-center space-x-8">
              <a href="#about" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">学院について</a>
              <a href="#features" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">3大特長</a>
              <a href="#courses" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">コース一覧</a>
              <a href="#contact" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">お問い合わせ</a>
              <Button size="sm" onClick={handleExplanationClick}>
                説明会申込み
              </Button>
            </nav>

            {/* モバイルメニューボタン */}
            <div className="md:hidden">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="text-gray-700 hover:text-blue-600 cursor-pointer"
              >
                <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
              </button>
            </div>
          </div>

          {/* モバイルメニュー */}
          {isMenuOpen && (
            <div className="md:hidden py-4 border-t border-gray-200">
              <div className="flex flex-col space-y-4">
                <a href="#about" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">学院について</a>
                <a href="#features" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">3大特長</a>
                <a href="#courses" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">コース一覧</a>
                <a href="#contact" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">お問い合わせ</a>
                <Button size="sm" onClick={handleExplanationClick} className="w-fit">
                  説明会申込み
                </Button>
              </div>
            </div>
          )}
        </div>
      </header>
    </>
  );
};

export default Header;
